import "../stylesheets/App.css";
import "../stylesheets/MyScore.css";
import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";

import Header from "./subcomponents/Header.js";
import StageItem from "./subcomponents/StageItem.js";
import GameMyScore from "./subcomponents/GameMyScore.js";
import Loader from "./subcomponents/Loader.js";

function MyScore() {
  const navigate = useNavigate();

  const stageHeader = {
    idStage: 7,
    name: "Mis puntos",
    total_score: 50,
    partial_score: 20,
    background_url: "\\\\images\\\\stage_banners\\\\BLUE_CARD.png",
    character_url: "\\\\images\\\\stage_characters\\\\BLUE_MYSCORE.png",
    active: 1,
  };

  const [loadingStages, setLoadingStages] = useState(true);
  const [loadingBets, setLoadingBets] = useState(true);
  const [loadingScores, setLoadingScores] = useState(true);

  const [stages, setStages] = useState([]);
  const [bets, setBets] = useState([]);
  const [scores, setScores] = useState([]);
  const [scoreTotal, setScoreTotal] = useState(0);
  const [keywords, setKeywords] = useState("");

  // Accordion (qué stages están abiertos)
  const [openIndexes, setOpenIndexes] = useState(() => new Set());

  const toggleOpen = (i) => {
    setOpenIndexes((prev) => {
      const next = new Set(prev);
      if (next.has(i)) next.delete(i);
      else next.add(i);
      return next;
    });
  };

  // ✅ auth/redirect dentro de useEffect (no en render)
  useEffect(() => {
    const raw = localStorage.getItem("user-info");
    if (!raw) {
      navigate("/login");
      return;
    }
    const user = JSON.parse(raw);
    if (user?.is_admin) {
      navigate("/admin");
      return;
    }

    const controller = new AbortController();

    const run = async () => {
      try {
        const idUser = user.idUser;

        // ✅ Bets y Scores en paralelo
        const [betsRes, scoresRes] = await Promise.all([
          fetch(`${process.env.REACT_APP_API_BASE_URL}/bets/listByUser/${idUser}`, {
            signal: controller.signal,
          }).then((r) => r.json()),
          fetch(`${process.env.REACT_APP_API_BASE_URL}/scores/listByUser/${idUser}`, {
            signal: controller.signal,
          }).then((r) => r.json()),
        ]);

        setBets(betsRes?.data || []);
        setLoadingBets(false);

        const scoresData = scoresRes?.data || [];
        setScores(scoresData);
        setScoreTotal(scoresData.reduce((acc, s) => acc + (s.score || 0), 0));
        setLoadingScores(false);
      } catch (e) {
        console.log(e);
        setLoadingBets(false);
        setLoadingScores(false);
      }
    };

    run();
    return () => controller.abort();
  }, [navigate]);

  // ✅ Stages (MyScore) con/ sin keywords
  useEffect(() => {
    const controller = new AbortController();

    const run = async () => {
      setLoadingStages(true);
      try {
        const url =
          keywords?.trim() !== ""
            ? `${process.env.REACT_APP_API_BASE_URL}/stages/listWithGamesWithKeywords/${keywords}`
            : `${process.env.REACT_APP_API_BASE_URL}/stages/listWithGames`;

        const res = await fetch(url, { signal: controller.signal }).then((r) =>
          r.json()
        );

        setStages(res?.data || []);
      } catch (e) {
        console.log(e);
        setStages([]);
      } finally {
        setLoadingStages(false);
      }
    };

    run();
    return () => controller.abort();
  }, [keywords]);

  // ✅ Maps para lookup rápido (evita .find() y loops repetidos)
  const betByGameId = useMemo(() => {
    const m = new Map();
    bets.forEach((b) => {
      const gid = b?.game?.idGame;
      if (gid != null) m.set(gid, b);
    });
    return m;
  }, [bets]);

  const scoreByGameId = useMemo(() => {
    const m = new Map();
    scores.forEach((s) => {
      if (s?.idGame != null) m.set(s.idGame, s);
    });
    return m;
  }, [scores]);

  return (
    <>
      <Header setKeywords={setKeywords} keywords={keywords} />

      <section className="stage-page score-page">
        <StageItem stage={stageHeader} total={scoreTotal} />

        {stages?.map((st, i) => {
          // ✅ total por fase sin loops cruzados
          const totalByStage = (st.games || []).reduce((acc, g) => {
            const sc = scoreByGameId.get(g.idGame);
            return acc + (sc?.score || 0);
          }, 0);

          const isOpen = openIndexes.has(i);

          return (
            <div className="score-stage-container" key={`score-container-${st.idStage}`}>
              <div
                className="score-stage-title-container"
                key={`score-title-${st.idStage}`}
                onClick={() => toggleOpen(i)}
              >
                <h1 className="score-stage-title">
                  {st.name === "Fase de clasificación" ? "Fase de\nclasificación" : st.name}
                </h1>

                <p className="score-total-by-stage">Total: {totalByStage} puntos</p>

                <div className={`stage-icon ${isOpen ? "active" : ""}`} id={`icon-${i}`}>
                  <FontAwesomeIcon icon={solid("chevron-down")} />
                </div>
              </div>

              <div id={`list-${i}`} className={`teams-by-stage-list ${isOpen ? "active" : ""}`}>
                {(st.games || []).map((game) => (
                  <GameMyScore
                    key={`score-game-${game.idGame}`}
                    data={game}
                    bet={betByGameId.get(game.idGame)}
                    score={scoreByGameId.get(game.idGame)}
                  />
                ))}
              </div>
            </div>
          );
        })}
      </section>

      {(loadingStages || loadingBets || loadingScores) ? <Loader /> : null}
    </>
  );
}

export default MyScore;
